import React from 'react';

function WebShareButton({ clientUuid, clientUsername  }) {
  // 1) Web Share API 실행 함수
  const shareToWeb = async () => {
    if (!navigator.share) {
      alert('해당 브라우저에서 WebShare 기능이 제공되지 않습니다');
      return;
    }

    try {
      // 2) 공유 데이터 설정 및 공유 실행
      await navigator.share({
        title: '🌅Sunrise2025',
        text: `Sunrise2025에서 목표를 이루며 해를 높이는 중입니다.\n당신의 작은 응원이 큰 힘이 됩니다! 🌞 \n${clientUsername}님의 해가 더 높이 뜨도록 함께 응원해 주세요.`,
        url: `https://sunrisetogether2025.fly.dev/userSun/${clientUuid}`,
      });
      console.log('Content shared successfully');
    } catch (error) {
      console.error('Error sharing content:', error);
    }
  };

  return (
    <button onClick={shareToWeb} className="share-button">
              <span className="emoji-button">⬆️</span>
              <span className="button-text">웹 공유</span>
    </button>
  );
}

export default WebShareButton;